import { useEffect, useState } from "react";
import { useAppDispatch } from "@grassrootly/rn-core";
import { GetOfficialCompetitions, ICompetitionView } from "@grassrootly/api";
import { competitionsActions } from "../../api/competitions/CompetitionsReducer";
import { useCompetitions } from "../../api/competitions/CompetitionsSelector";

export const useCompetitionsList = () => {
  const dispatch = useAppDispatch();
  const competitions = useCompetitions();
  const [loading, setLoading] = useState(false);

  const fetchCompetitions = async () => {
    try {
      setLoading(true);
      const data = await GetOfficialCompetitions();
      dispatch(competitionsActions.setCompetitions(data));
    } catch (error) {
      console.error("Error fetching competitions:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (competitions.length === 0) {
      fetchCompetitions();
    }
  }, []);

  const refreshCompetitions = async () => {
    await fetchCompetitions();
  };

  return {
    competitions,
    loading,
    refreshCompetitions,
  };
};
